import Section, { SectionHeadline } from '@components/Section';
import Button from '@components/UI/Button';
import Container from '@components/UI/Container';
import Picture from '@components/UI/Picture';
import Heading from '@components/UI/Typography/Heading';
import Paragraph from '@components/UI/Typography/Paragraph';
import useUtmTags, { Utm } from '@hooks/useUtmTags';

import happyPeopleAttraqqImage from '@images/happy-people-at-traqq.png';
import traqqUiOverview from '@images/traqq2-ui-overview.svg';
import traqqTimeTrackerTeamImage from '@images/traqq-time-tracker-team.png';
import traqqUsedWorldwideImage from '@images/traqq-used-worldwide.png';

import { Navigation } from "@layouts/NavigationV2"
import Image from 'next/image';

const AboutUs = () => (
    <>
        <Navigation
            staticTheme="neutral"
            actionTheme="neutral"
        />

        <Section
            mods={ {
                'bg-neutral': 900,
                'no-spacing': true,
                py: 18
            } }
        >
            <Container>
                <SectionHeadline
                    mods={ {
                        w: 75,
                        center: true
                    } }
                >
                    <Heading
                        tag='h1'
                        color='white'
                    >
                        Who we are
                    </Heading>

                    <Paragraph
                        tag='p'
                        color='white'
                        size='lg'
                    >
                        We are a fast growing privately owned company with a team consisting of bright, driven and passionate people working hard to provide you with the best productivity software.
                    </Paragraph>
                </SectionHeadline>

                <div className='justify-center mb-20'>
                    <Image
                        src={ traqqTimeTrackerTeamImage }
                        sizes='100vw'
                        priority={ true }
                        alt='The team of Traqq time tracker'
                        className={"mx-auto"}
                    />
                </div>

                <div className='mb-20'/>

                { /* TODO: come up with a name for the block */ }
                <div className='justify-center px-5 py-10 md:px-24 md:pt-20 d-flex rounded-[3rem] bg-gradient-to-b from-[rgba(52,50,67,1)] to-[rgba(52,50,67,0)]'>
                    <SectionHeadline
                        mods={ { center: true } }
                    >
                        <h2
                            className='heading heading_white h1'
                        >
                            What is Traqq
                        </h2>

                        <Paragraph
                            tag='p'
                            color='white'
                            size='lg'
                        >
                            Most time tracking tools are built to measure activity.
                            Traqq is built to understand work.
                            Tracked time becomes the foundation for workload, projects, client work, and billing.
                            Traqq shows how projects are progressing, not what someone was doing at every moment.
                        </Paragraph>
                    </SectionHeadline>

                    <div
                        className='xl:max-w-[720px] xl:mx-auto'
                    >
                        <Picture
                            image={ happyPeopleAttraqqImage }
                            alt='Happy people at Traqq'
                            sizes='50vw'
                            theme='dark'
                        />
                    </div>
                </div>

                <div className='mb-20'/>

                <SectionHeadline
                    mods={ {
                        center: true,
                        w: 75
                    } }
                >
                    <h2
                        className='heading heading_white h1'
                    >
                        What we offer
                    </h2>

                    <Paragraph
                        tag='p'
                        color='white'
                        size='lg'
                    >
                        Traqq combines time tracking, reporting, billing, and project financial insights in one system.
                        Employees log time across tasks and projects.
                        The same data supports workload planning, project reporting, invoicing, and capacity management.
                    </Paragraph>

                    <Button
                        tag='a'
                        type='link'
                        variant='primary'
                        href={ useUtmTags(`${process.env.NEXT_PUBLIC_APP_TRAQQ_URL}/signup`,
                            {
                                utm_campaign: Utm.CAMPAIGN.BUTTON,
                                utm_term: 'Start tracking'
                            }) }
                    >
                        Start tracking
                    </Button>
                </SectionHeadline>

                <Picture
                    image={ traqqUiOverview }
                    alt='Traqq UI overview'
                    sizes='100vw'
                    theme='dark'
                />

                <div className='mb-20'/>

                <SectionHeadline
                    mods={ {
                        center: true,
                        w: 75
                    } }
                >
                    <h2
                        className='heading heading_white h1'
                    >
                        Designed in Australia for worldwide use
                    </h2>

                    <Paragraph
                        tag='p'
                        color='white'
                        size='lg'
                    >
                        Traqq is based in Sydney, Australia, and we work hard to make our products match the high quality standards traditional for the land down under. Our time tracker is continually tested and improved to ensure smooth operation.
                    </Paragraph>
                </SectionHeadline>

                <Picture
                    image={ traqqUsedWorldwideImage }
                    alt='Traqq is designed in Australia for use worldwide'
                    sizes='100vw'
                    theme='dark'
                />
            </Container>
        </Section>
    </>
);

export default AboutUs;
